import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query"

import { fetchKioskConfig, IKioskConfigRecord } from "services/venue"
import { IKioskConfigData } from "./interface"
import { prepareKioskConfig } from "./utils/prepareKioskConfig"

const DEFAULT_KIOSK_CONFIG = [] as IKioskConfigRecord[]
const DEFAULT_QUERY_OPTIONS = {}

export type UseGetKioskConfigOptions = Pick<
  UseQueryOptions<IKioskConfigRecord[], unknown, IKioskConfigData>,
  "gcTime" | "enabled" | "staleTime" | "refetchOnWindowFocus" | "retry"
>
export type UseGetKioskConfig = (
  name: string,
  options?: UseGetKioskConfigOptions
) => UseQueryResult<IKioskConfigData, any>

export const useGetKioskConfig: UseGetKioskConfig = (
  name: string,
  options = DEFAULT_QUERY_OPTIONS
) => {
  return useQuery<IKioskConfigRecord[], unknown, IKioskConfigData>({
    queryKey: ["kiosk-config", name],
    queryFn: async () => {
      try {
        const appConfig = await fetchKioskConfig(name)
        return appConfig || DEFAULT_KIOSK_CONFIG
      } catch (err) {
        return DEFAULT_KIOSK_CONFIG
      }
    },
    select: (data: IKioskConfigRecord[]): IKioskConfigData =>
      prepareKioskConfig(data),
    initialData: DEFAULT_KIOSK_CONFIG,
    retry: false,
    enabled: !!name,
    refetchOnWindowFocus: false,
    ...options,
  })
}
